import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  TabPanel,
  Tabs,
  TabsBody,
  Typography,
} from "@material-tailwind/react";
import Label from "components/Label/Label";
import React, { useState } from "react";
import ButtonSecondary from "shared/Button/ButtonSecondary";

interface PlanFeatureDetailProps {
  open: boolean;
  handleClose?: () => void;
  data: {
    id?: number;
    description?: string;

    createdAt?: string;
    updatedAt?: string;
  } | null;
}

const PlanFeatureDetail: React.FC<PlanFeatureDetailProps> = ({ open, handleClose, data }) => {
  const [activeTab, setActiveTab] = useState("details");

  const formatMessage = (message?: string) => {
    if (!message) return "N/A";
    return message.replace(/\r\n/g, " ").replace(/\s+/g, " ").trim();
  };

  const fieldIcons = {
    message: "las la-comment",
  };

  // Tab data
  const tabs = [{ label: "", value: "details" }];

  return (
    <Dialog
      open={open}
      handler={() => console.log}
      className="w-full max-w-2xl mx-auto transition-all duration-300 bg-white shadow-2xl rounded-2xl dark:bg-gray-900"
    >
      <DialogHeader className="flex items-center justify-center p-6 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-t-2xl">
        <Typography variant="h5" className="font-bold tracking-tight text-center text-white animate-fade-in">
          Détails
        </Typography>
      </DialogHeader>
      <DialogBody className="p-6 max-h-[70vh] overflow-y-auto">
        <Tabs value={activeTab} onChange={(value: any) => setActiveTab(value as string)} className="w-full">
          <TabsBody className="mt-4">
            {/* Basic Information Tab */}

            {/* Details Tab */}
            <TabPanel value="details" className="space-y-4">
              {[
                {
                  label: "Description",
                  value: formatMessage(data?.description),
                  icon: fieldIcons.message,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="p-3 transition-shadow duration-200 rounded-lg shadow-sm bg-gray-50 dark:bg-gray-800 hover:shadow-md"
                >
                  <div className="flex flex-col space-y-2">
                    <div className="flex items-center space-x-2">
                      <i className={`${item.icon} text-xl text-blue-500 dark:text-blue-400`}></i>
                      <Label className="font-semibold text-gray-700 dark:text-gray-200">{item.label} :</Label>
                    </div>
                    <Typography className="font-medium text-gray-900 dark:text-white">
                      {item.value || "N/A"}
                    </Typography>
                  </div>
                </div>
              ))}
            </TabPanel>
          </TabsBody>
        </Tabs>
      </DialogBody>
      <DialogFooter className="flex justify-center p-4 space-x-4 bg-gray-50 dark:bg-gray-800 rounded-b-2xl">
        <ButtonSecondary
          onClick={handleClose}
          className="px-6 py-2 text-gray-900 transition-colors duration-200 bg-gray-200 rounded-full dark:bg-gray-700 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-600"
        >
          Quitter
        </ButtonSecondary>
      </DialogFooter>
    </Dialog>
  );
};

export default PlanFeatureDetail;
